import { Component, OnInit, WritableSignal, signal } from '@angular/core';
import { SelectModule } from 'primeng/select';
import { FormsModule } from '@angular/forms';
import {TableRow, TableColumn} from '../../../../shared/models/components/tables/table.models';
import {StandardDropdown} from '../../../../shared/models/components/dropdowns/standardDropdown.models';
import {ModelDefinitionsService} from '../../../../shared/services/componentsServices/modelDefinitions.service';
import {ModelPredictionsService} from '../../../../shared/services/componentsServices/modelPredictions.service';
import {   ProjectInputsByModel } from '../../../../shared/models/components/tables/projectInputsByModel.model';
import {   ModelInput } from '../../../../shared/models/components/tables/projectInputsByModel.model';
import {   ProjectData } from '../../../../shared/models/serviceModels/request/modelDefinitionsReq.model';
import {   projectInputsByModelResponse } from '../../../../shared/models/serviceModels/response/model-definitions-response.models';
import { CommonModule } from '@angular/common';
import { Table, TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { NumberInput } from '@angular/cdk/coercion';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSnowflake } from '@fortawesome/free-solid-svg-icons';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { faCircle } from '@fortawesome/free-solid-svg-icons';
import { NotificationPopupComponent } from '../../../../shared/components/notification-popup/notification-popup.component';
import {modelDefinitionsResponse} from '../../../../shared/models/serviceModels/response/model-definitions-response.models';

@Component({
    selector: 'app-model-definitions',
  imports: [
    NotificationPopupComponent,
    SelectModule,
        CommonModule,
        TableModule,
        FormsModule,
        TooltipModule,
        FontAwesomeModule
    ],
    templateUrl: './model-definitions.component.html',
    styleUrl: './model-definitions.component.scss'
})
export class ModelDefinitionsComponent implements OnInit {

  inputsColumns: TableColumn[]=[];
  inputsRows: TableRow[] =[];
  modelsInputs: ProjectInputsByModel = {
    projectId: '',
    projectName: '',
    errorMsg: null,
    inputsByModel: []
  };

  benchmarkColumns: WritableSignal<TableColumn[]>  = signal([]);
  benchmarkRows: WritableSignal<TableRow[]>  = signal([]);
  currentProject: number = 0;
  currentScope: number = 1;
  rowsCategories: WritableSignal<string[]>  = signal([]);
  selectedCommodity: any = null;
  faSnowflake = faSnowflake;

  scenarioDropdown:  WritableSignal<StandardDropdown[]>  = signal([]);
  selectedScenario: StandardDropdown= {description: "", value: ""};

  isFlagVisible = signal(false);
  flagMessage = signal('');
  flagClassName = signal('');
  flagIcon = signal('');

  emptyModuleMessage = signal('Loading models and inputs...');
  isModelDataVisible:WritableSignal<boolean> = signal(false);

  errorMessage: WritableSignal<string> = signal("") ;
  secondErrorMessage: WritableSignal<string> = signal("") ;
  isNotificationPopupOpen = signal(false);

  constructor(private modelDefinitionsService: ModelDefinitionsService, private modelPredictionsService: ModelPredictionsService){
    this.rowsCategories = this.modelPredictionsService.getCurrentCategories();
  };

  ngOnInit(): void {
    this.currentProject = this.modelPredictionsService.getCurrentProject();
    this.currentScope = this.modelPredictionsService.getCurrentScope();
    // this.getCasesDataForDropdown();
    // this.selectedScenario = this.scenarioDropdown()[0];
    this.getServiceData();
    this.setFlag();
  }

  getServiceData(){
    let reqData:ProjectData ={
      id: this.currentProject,
      scope: this.currentScope
    };

    this.modelDefinitionsService.getProjectInputsByModel(reqData).subscribe({
      next: (data: modelDefinitionsResponse | null | undefined) => {

        this.modelsInputs = this.mapDataFromResponse(data);

        if(this.modelsInputs.errorMsg){
          this.handleErrorMessage(this.modelsInputs.errorMsg, "Please go back to model prediction tab and try again.");
          return;
        }

        this.inputsColumns = this.modelPredictionsService.getInputColumns()();
        this.inputsRows = this.modelPredictionsService.getInputRows()();

        this.getCasesDataForDropdown();
        this.selectedScenario = this.scenarioDropdown()[0];
       
        this.setDataForBenchmark();

        this.isModelDataVisible.set(true);
      },
      error: (error) => {
        const errorMessage = error?.error?.title || error?.message || 'Unable to load model definitions.';
        this.handleErrorMessage(errorMessage, 'Please go back to model prediction tab and try again.');
      }
    });
  }

  closeNotificationPopup(){
    this.isNotificationPopupOpen.set(false);
  }

  handleErrorMessage(errorMessage: string, secondErrorMessage: string = "") {
    let errorMsg = `An error occurred while running the model: ${errorMessage}`;
    this.errorMessage.set(errorMsg);
    this.secondErrorMessage.set(secondErrorMessage);
    this.isNotificationPopupOpen.set(true);
  }

  setFlag() {
    this.isFlagVisible.set(false);
    this.flagMessage.set('');
    if (this.currentProject===1 && this.currentScope===2 ) {
      this.isFlagVisible.set(true);
      this.flagClassName.set('winter');
      this.flagIcon.set('faSnowflake');
      this.flagMessage.set("Winter months");
    }
  }

  mapDataFromResponse(data: modelDefinitionsResponse | null | undefined): ProjectInputsByModel {
    let responseData: ProjectInputsByModel = {};

    if (!data) {
      responseData.errorMsg = 'Empty response received while loading model definitions.';
      return responseData;
    }

    if (data.errorMsg !== null && data.errorMsg !== undefined && data.errorMsg.length > 0) {
      responseData.errorMsg = data.errorMsg;
      return responseData;
    }

    responseData.projectId = data.projectId || '';
    responseData.projectName = (data.projectName || '').trim();

    let inputsByModelList: ModelInput[] = [];

    const serviceInputs = Array.isArray(data.inputsByModel) ? data.inputsByModel : [];

    serviceInputs.forEach((item: any) => {
      if (!item) {
        return;
      }

      let inputsByModelItem: ModelInput = {
        uiModelName: item.uiModelName || '',
        modelId: item.modelId || '',
        inputsIds: Array.isArray(item.inputIds) ? item.inputIds : [],
        fieldName: item.fieldName || '',
        errorMsg: item.errorMsg || null
      };
      inputsByModelList.push(inputsByModelItem);
    });

    responseData.inputsByModel = inputsByModelList;

    return responseData;
  }

  setDataForBenchmark(){
    let currentSelectedScenario = {...this.selectedScenario};

    let currentModelsInputs = this.modelsInputs.inputsByModel?.slice() || [];
    
    let currentInputRows =  this.inputsRows.slice();

    let currentBenchmarkColumns: TableColumn[]=[];
    let currentBenchmarkRows: TableRow[]=[];

    this.benchmarkColumns.set([]);
    this.benchmarkRows.set([]);

    this.createBenchmarkColumns(currentBenchmarkColumns, currentModelsInputs);
    // this.sortBenchmarkColumns(currentBenchmarkColumns);
    this.benchmarkColumns.set(currentBenchmarkColumns);

    currentBenchmarkRows = this.createBenchmarkRows(currentInputRows, currentModelsInputs, currentSelectedScenario);
    this.benchmarkRows.set(currentBenchmarkRows);
   
  }

  createBenchmarkColumns(currentBenchmarkColumns: TableColumn[], currentModelsInputs: ModelInput[]) {
    let firstTableItem: TableColumn={
        header: "",
        editable: false,
        field: "field",
        name: "name",
        deletable: false,
        isFrozen: true,
        fieldDescription: ""      
    }
    currentBenchmarkColumns.push(firstTableItem);

    currentModelsInputs.forEach(model=>{
      let tableItem: TableColumn={
        header: model.uiModelName ?? "",
        editable: true,
        field: model.uiModelName?.replace(/\s+/g, '').toLowerCase() ?? "",
        name:model.uiModelName ?? "",
        deletable: true,
        isFrozen: false,
        fieldDescription: model.fieldName ?? ""
      }

      currentBenchmarkColumns.push(tableItem);
    })
  }

  sortBenchmarkColumns(currentBenchmarkColumns: TableColumn[]) {
    currentBenchmarkColumns.sort((a, b) => {
      if (a.header === "") {
        return -1;
      } else if (b.header === "") {
        return 1;
      } else {
        return a.header.localeCompare(b.header);
      }
    });
  }

  createBenchmarkRows(currentInputRows: TableRow[], currentModelsInputs: ModelInput[], currentSelectedScenario: StandardDropdown) {
    return currentInputRows.map(row => {
      const newRow: TableRow = { 
        field: row.field, 
        inputId: row.inputId,
        maxVal: row.maxVal,
        minVal: row.minVal,
        percentile10: row.percentile10,
        percentile90: row.percentile90,
        name: row.name, 
        description: row.description,
        dataCategory: row.dataCategory         
      };

      currentModelsInputs.forEach(model => {
        const fieldName = model.uiModelName?.replace(/\s+/g, '').toLowerCase() ?? "";
        let inputId= row.inputId!;
        newRow[fieldName] = model.inputsIds?.includes(+inputId) 
                            ? row[currentSelectedScenario?.value ?? ''] ?? '' 
                            : '';
      });
      return newRow;
    });
  }

  getTooltipForHeaderText(col: TableColumn, columnIndex: number): string{
    let tooltipText = '';
    if(col.fieldDescription !== undefined && col.fieldDescription.length>0){
      tooltipText= `${col.fieldDescription}`;
    }
    return tooltipText;
  }

  getTooltipText(row: TableRow, column: TableColumn, columnIndex: number): string {
    const value = row[column.field];
    
    if (columnIndex === 0) {
      return `${row.description}`;
    }

    if(value=== undefined || value === null || value === ''){
      return '';
    }

    let numberValue = Number(value);
    let numericMaxVal = Number(row.percentile90);
    let numericMinVal = Number(row.percentile10);
    if((numericMaxVal && numberValue > numericMaxVal) || (numericMinVal && numberValue < numericMinVal)){
      return `Outside of training range: ${row.percentile10} - ${row.percentile90}`;
    }

    
    return '';
  }


getCellColor(row: TableRow, column: TableColumn, columnIndex: number): string {
  const value = row[column.field];
  if (columnIndex === 0) {
    return 'default'; 
  }

  if(value=== undefined || value === null || value === ''){
    return '';
  }

  let numberValue = Number(value);
  let numericMaxVal = Number(row.percentile90);
  let numericMinVal = Number(row.percentile10);
  if(numericMaxVal && numberValue >numericMaxVal){
    return "higher"
  }
  if(numericMinVal && numberValue < numericMinVal){
    return "lower"
  }
  return 'default'; 
}

getCellClasses(row: TableRow, column: TableColumn, columnIndex: number){
  const classes: string[] = [];
  
  const value = Number(row[column.field]);
  const rowMaxVal = Number(row.percentile90);
  const rowMinVal = Number(row.percentile10);

  if(!row[column.field]){
    return "";
  }

  if(rowMaxVal == null && rowMinVal == null){
    classes.push('default-cell'); 
    return classes.concat();}

 
  if(columnIndex === 0){
    classes.push('frozen-column');
    return classes.concat();
  }


  if( rowMaxVal !== undefined && value > rowMaxVal){
    classes.push('higher-cell');
    return classes.concat();
    // return "#e21836" RED
  }
  if(rowMinVal!== undefined && value < rowMinVal){
    classes.push('lower-cell');
    return classes.concat();
    // return "#0066b2"
  }
  classes.push('default-cell');

  return classes.concat();
}

getRowClass(row: TableRow): string {
  const category = row.dataCategory?.toLowerCase() || 'default';
  return `${category}-row`;
}

  onScenarioChange(event: any) {
    
    this.setSelectedScenario(event.value);
    this.setDataForBenchmark();

  }

  setSelectedScenario(scenario:string){

    let newScenario: StandardDropdown= this.scenarioDropdown().find(item=> item.value===scenario) || this.selectedScenario;

    this.selectedScenario= newScenario;

  }
  
  getCasesDataForDropdown(){
    let dropdownData:StandardDropdown[]= [];

      this.inputsColumns.forEach(item=>{
        let currentItem: StandardDropdown={
          description: item.header,
          value: item.field
        }

        dropdownData.push(currentItem);
      })

      let finalDDD= dropdownData.slice(1); 
      this.scenarioDropdown.set(finalDDD);
  }

 
  
}                
